import config from "@/config"
import http from "@/utils/request"

export default {
	getVoiceTags: {
		url: `${config.API_URL}/voice/getVoiceTags`,
		name: "获取音色情感标签",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	save: {
		url: `${config.API_URL}/voice/save`,
		name: "新增音色",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	getList: {
		url: `${config.API_URL}/voice/getList`,
		name: "我的音色列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	changeName: {
		url: `${config.API_URL}/voice/changeName`,
		name: "音色修改名称",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	getCommonVoice: {
		url: `${config.API_URL}/voice/getCommonVoice`,
		name: "获取公共音色",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	delete: {
		url: `${config.API_URL}/voice/delete`,
		name: "删除音色",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
}
